import React, { useState } from 'react';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Container,
  Button,
  List,
  ListItem
} from '@chakra-ui/react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { useResendSourcingEmail } from '../hooks/useSourcingEmail';

const Success = () => {
  const history = useHistory();
  const location = useLocation();

  const { state: initialState } = location;
  const [record, setRecord] = useState(initialState?.[0]);
  const resendEmail = useResendSourcingEmail();

  // Page refreshed / opened directly: there is no result to show.
  if (!record) {
    return <Redirect to='/sourcing' />;
  }

  const emailSent = record.email_status === 'sent';

  return (
    <Container>
      <Alert
        status='success'
        marginTop='2'
        variant='subtle'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        height='full'
        textAlign='center'
      >
        <AlertIcon boxSize='40px' mr={0} />
        <AlertTitle mt={4} mb={1} fontSize='lg'>
          Sourcing Successful
        </AlertTitle>
        <AlertDescription maxWidth='sm'>
          The following products have been sourced
        </AlertDescription>
        <List spacing={3}>
          <ListItem>
            LPO Number: <strong>{record?.lpo_number}</strong>
          </ListItem>
          <ListItem>
            Supplier: <strong>{record?.supplier.display_name}</strong>
          </ListItem>

          <ListItem>
            Produce:{" "}
            <strong>
              {record?.notes?.includes("Product:")
                ? `${record?.product_type?.name} - ${record.notes.split(".")[0].replace("Product: ", "")}`
                : record?.product_type?.name}
            </strong>
          </ListItem>
          <ListItem>
            Quality Score: <strong>{record?.quality_score}</strong>
          </ListItem>
          <ListItem>
            Cost Per Kg: <strong>{record?.cost_per_kg}</strong>
          </ListItem>

          <ListItem>
            Total Weight: <strong>{record?.total_net_weight}</strong>
          </ListItem>
        </List>

        <Alert
          status={emailSent ? 'success' : 'warning'}
          marginTop='4'
          borderRadius='md'
          flexDirection='column'
        >
          <AlertTitle fontSize='sm'>
            {emailSent
              ? 'LPO email sent to the finance & supply team'
              : 'LPO saved, but the email was NOT sent'}
          </AlertTitle>
          {!emailSent && (
            <>
              <AlertDescription fontSize='sm'>
                Please resend it so finance is notified.
              </AlertDescription>
              <Button
                size='sm'
                marginTop='2'
                colorScheme='orange'
                isLoading={resendEmail.isLoading}
                onClick={() =>
                  resendEmail.mutate(record.id, { onSuccess: setRecord })
                }
              >
                Resend email
              </Button>
              {resendEmail.isError && (
                <AlertDescription fontSize='xs' marginTop='1'>
                  Resend failed. Try again shortly.
                </AlertDescription>
              )}
            </>
          )}
        </Alert>

        <Button
          colorScheme='purple'
          marginTop='2'
          variant='outline'
          onClick={() => history.push('/sourcing')}
        >
          Go Back
        </Button>
      </Alert>
    </Container>
  );
};

export default Success;